import { any } from "./app/data/features";

const globals = {
  debug: "0",
  locale: "en-US",
  app: undefined, // compute from location
  cdn: "./node_modules",
  services: "//usgvdcalix2/860RS/api",
  GoogleMapsKey: "[GOOGLE-API-KEY]",
  GoogleMapsUrl: "https://www.google.com/maps",
  proxy: "http://usgvdcalix2:94/proxy/Proxy.ashx?",
  runner: "app/run",
  api: "app/app",
  controller: "app/applications/rhythm-gis-app",
  cachebust: "0",
  stub: "0",
  layerList: [],
  paths: () => {
    var paths = {};
    if (location.search) {
      var nv = location.search
        .substring(1)
        .split("&")
        .map((nv) => nv.split("="))
        .forEach((nv) => (paths[nv[0]] = nv[1]));
    }
    return paths;
  },
};

export = globals;
